// components/LoadingScreen.js
import React from "react";
import "../styles/loading.css";
import { FaSpinner } from "react-icons/fa";

export default function LoadingScreen() {
  return (
    <div className="loading-overlay">
      <div className="loading-box">
        <FaSpinner className="spinner" />
        <span className="loading-text">Loading...</span>
      </div>
    </div>
  );
}